module.exports = __webpack_public_path__ + "static/media/floor_tom_1.c43c6e8d.png";